const ModifyAddress = {
    template: ` <div v-if="isPackagePoint">
                    <h3>${langhelp.address.package_point}</h3>
                    <div class="package-point-search">
                        <div class="form-group">
                            <label for="package-point-post-code">${langhelp.address.post_code}</label>
                            <input id="package-point-post-code" type="text" v-model="mapPostCode" @keyup.enter="fetchPackagePoints">
                        </div>
                        <button type="button" class="btn btn-white" :disabled="pointsLoading || !mapPostCode" @click="fetchPackagePoints">${langhelp.address.refresh_points}</button>
                    </div>
                    <div v-if="pointsLoading" class="package-point-state">${langhelp.address.loading_points}</div>
                    <div v-if="selectedPoint" class="package-point-selected">
                        <div class="package-point-selected__icon"><img v-if="selectedPoint.icon" :src="selectedPoint.icon" :alt="selectedPoint.name || ''"></div>
                        <div class="package-point-selected__content">
                            <strong>${langhelp.address.selected_point}</strong>
                            <b v-text="selectedPoint.name"></b>
                            <span><span v-text="selectedPoint.postCode"></span>, <span v-text="selectedPoint.city"></span>, <span v-text="selectedPoint.street"></span></span>
                            <small v-if="selectedPoint.openingTime" v-text="selectedPoint.openingTime"></small>
                        </div>
                    </div>
                    <div v-if="!pointsLoading && points.length === 0" class="package-point-state">${langhelp.address.no_points}</div>
                    <div class="package-points-list" v-if="!pointsLoading && alternativePoints.length > 0">
                        <h2>${langhelp.address.select_point}</h2>
                        <div class="form-group" v-for="(point, i) in alternativePoints" :key="point.pointId">
                            <input :id="'modify-point-'+i" type="radio" name="modifyPackagePoint" :value="point.pointId" v-model="delivery.package_point" @change="selectPoint(point)">
                            <label :for="'modify-point-'+i" class="pure-g package-point-option">
                                <span class="pure-u-1-12 package-point-option__radio"></span>
                                <span class="pure-u-1-4 pure-u-md-1-6 package-point-option__icon"><img v-if="point.icon" :src="point.icon" alt=""></span>
                                <span class="pure-u-7-12 pure-u-md-2-3 package-point-option__content"><strong v-text="point.name"></strong><span><span v-text="point.postCode"></span>, <span v-text="point.city"></span> <span v-text="point.street"></span></span><small v-if="point.openingTime" v-text="point.openingTime"></small></span>
                                <span class="pure-u-1-12 package-point-option__check">&#10003;</span>
                            </label>
                        </div>
                    </div>
                    <p class="alert alert-danger" v-if="packagePointError" v-text="packagePointError"></p>
                    <button type="button" class="btn btn-primary" :disabled="!selectedPoint" @click="handleSubmit()">${langhelp.finish}</button>
                </div>
                <div v-else><h3>${langhelp.address.edit}</h3>
                <template v-if="errors" v-for="(err,index) in errors" :key="index">
                    <template v-for="(msg,index) in err" :key="index">
                        <p v-text="msg" style="color:red;"></p>
                    </template>
                </template>
               <address-fields v-if="addrCountry" prefix="modify" :country="addrCountry" :address="addr" :errors="noErrors"></address-fields>
        <div aria-live="polite">
             <div v-if="error" class="alert alert-danger" role="alert">{{error}}</div>
         </div>
                    <div class="pure-g justify-content-right">
                        <button type="button" class="btn btn-primary" v-on:click="handleSubmit()">${langhelp.finish}</button>
                    </div>
                     </div>`,
    props: ["order-id", "delivery-info", "delivery-method"],
    data() {
        return {
            id: null,
            delivery: {
                country_id: "",
                need_state: false,
                need_area: false,
                need_post_code: false,
                post_code: "",
                city: "",
                street: "",
                house: "",
                package_point: "",
            },
            errors: [],
            // the address fields depend on the country (AddressFields)
            addr: AddressFields.blank(),
            addrCountry: null,
            noErrors: {},
            points: [],
            selectedPoint: null,
            pointsLoading: false,
            pointSearchTimer: null,
            packagePointError: null,
            mapPostCode: "",
        };
    },
    mounted() {
        forms.load();

        this.setDeliveryInfo();
        if (this.isPackagePoint) {
            this.fetchPackagePoints();
        }
    },
    watch: {
        mapPostCode() {
            clearTimeout(this.pointSearchTimer);
            if (this.isPackagePoint && this.mapPostCode) {
                this.pointSearchTimer = setTimeout(() => this.fetchPackagePoints(), 500);
            }
        },
        delivery: {
            handler(val) {
                if (this.errors.length) this.errors = [];
            },
            deep: true,
        },
    },
    methods: {
        selectPoint(point) {
            this.selectedPoint = point;
            this.delivery = {
                ...this.delivery,
                package_point: point.pointId,
                post_code: point.postCode,
                city: point.city,
                street: point.street,
                house: "",
                state: "",
                area: "",
            };
        },
        async fetchPackagePoints() {
            if (!this.delivery.country_code || !this.deliveryMethod?.id || !this.mapPostCode) {
                this.packagePointError = "Package point delivery data is incomplete";
                return;
            }

            this.pointsLoading = true;
            this.packagePointError = null;
            try {
                const response = await fetch(`/api/package-points/${this.deliveryMethod.id}/${this.delivery.country_code}/${this.mapPostCode}`, {
                    headers: http.headers(),
                });
                if (!response.ok) {
                    this.packagePointError = "Unable to load package points";
                    return;
                }

                const data = await response.json();
                this.points = Array.isArray(data?.list) ? data.list : [];
                this.selectedPoint = this.points.find((point) => point.pointId === this.delivery.package_point) ?? null;
            } finally {
                this.pointsLoading = false;
            }
        },
        async handleSubmit() {
            const response = await fetch(
                `/api/orders/${this.orderId}/delivery/edit`,
                {
                    method: "POST",
                    headers: http.headers(),
                    body: JSON.stringify({
                        ...this.delivery,
                        ...(this.isPackagePoint ? {} : {post_code: this.addr.postcode, city: this.addr.city, street: this.addr.street, house: this.addr.house, state: this.addr.state, area: this.addr.area}),
                        method: this.deliveryMethod?.id,
                        token: Cookies.getItem("login_token"),
                    }),
                }
            ).catch((err) => console.log(err));
            const data = await response.json();

            if (!response.ok) {
                if(data.errors) {
                    this.errors = Object.values(data.errors);
                }
                if(data.error){
                    this.errors = [[data.error]];
                }
                return;
            }

            this.$emit('success');
            //this.$emit("refresh");
        },
        setDeliveryInfo() {
            if (this.deliveryInfo.length) {
                const info=this.deliveryInfo[0];
                this.delivery = {
                    country_id: info.country_id,
                    country_code: info.country_code || info.country?.code || "",
                    need_state: Boolean(info.country_requirements?.need_state),
                    need_area: Boolean(info.country_requirements?.need_area),
                    need_post_code: Boolean(info.country_requirements?.need_post_code),
                    post_code: info.post_code,
                    city: info.city,
                    street: info.street,
                    house: info.house,
                    package_point: info.package_point,
                };
                this.mapPostCode = info.post_code || "";
                this.addr = AddressFields.blank(info);

                document.querySelectorAll('.form-group').forEach(node=>{
                    node.classList.add('filled')
                })
            }
            if (this.delivery.country_id) {
                AddressFields.country(this.delivery.country_id).then((row) => { this.addrCountry = row; });
            }
        },
    },
    computed: {
        isPackagePoint() {
            return Boolean(this.delivery.package_point) || this.deliveryMethod?.type == 2;
        },
        sortedPoints() {
            if (!this.selectedPoint) {
                return this.points;
            }

            return [...this.points].sort((left, right) => {
                if (left.pointId === this.selectedPoint.pointId) return -1;
                if (right.pointId === this.selectedPoint.pointId) return 1;
                return 0;
            });
        },
        alternativePoints() {
            return this.points.filter((point) => point.pointId !== this.selectedPoint?.pointId);
        },
    },
};

export default ModifyAddress;
